import * as React from "react";
const SvgMap01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.622 1.074a1 1 0 0 1 .874.058l6.463 3.693 5.486-3.657A1 1 0 0 1 23 2v16a1 1 0 0 1-.445.832l-6 4a1 1 0 0 1-1.051.036L9 19.151l-6.504 3.717A1 1 0 0 1 1 22V6a1 1 0 0 1 .504-.868l7-4zM3 6.58v13.696l5-2.857V3.723zm7 10.839 5 2.857V6.58l-5-2.857zm7-10.884v13.596l4-2.666V3.868z"
}));
export default SvgMap01;
//# sourceMappingURL=Map01.js.map